import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneNumberInputComponent } from './phone-number-input.component';



@NgModule({
  declarations: [
    PhoneNumberInputComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PhoneNumberInputComponent
  ]
})
export class PhoneNumberInputModule { }
